import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEnvironmentVariableService = ( createDecorator('environmentVariableService'));
export { IEnvironmentVariableService };
